import { TweenVars } from "./Tween";
import { TimelineVars } from "./Timeline";

export abstract class TweenVarConvertor {
    public static convertTweenVars(vars: TweenVars): gsap.TweenVars {
        return vars as gsap.TweenVars;
    }

    public static convertBackTweenVars(vars: gsap.TweenVars): TweenVars {
        return vars as TweenVars;
    }

    public static convertTimelineVars(vars: TimelineVars): gsap.TimelineVars {
        return vars as gsap.TimelineVars;
    }

    public static convertBackTimelineVars(vars: gsap.TimelineVars): TimelineVars {
        return vars as TimelineVars;
    }
}